module.exports = new __parcel__URL__("shop_epic_ng_refill_image.421a35cd.png").toString();